import React from 'react';
import PropTypes from 'prop-types';

export const IconDark = ({ className }) => (
  <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Moon">
      <path id="Vector" d="M11.3807 2.01855C9.91573 3.38737 9 5.33659 9 7.49968C9 11.6418 12.3579 14.9997 16.5 14.9997C18.6631 14.9997 20.6123 14.084 21.9811 12.619C21.6613 17.8534 17.3149 21.9997 12 21.9997C6.47715 21.9997 2 17.5225 2 11.9997C2 6.68483 6.14629 2.33838 11.3807 2.01855Z" fill="#F4F4F4" />
    </g>
  </svg>
);

IconDark.propTypes = {
  className: PropTypes.string,
};

IconDark.defaultProps = {
  className: '',
};
